module.exports = "<p>eon-ui-icon-button-custom works!</p>\n"